import * as R from 'remeda';
import { createSelector } from 'reselect';
import Types from 'Types';

export const domain = (state: Types.RootState) => state.data.improvementArea;

export const byId = createSelector(domain, (domain) => domain.byId);
export const allIds = createSelector(domain, (domain) => domain.allIds);

export const item = createSelector(
  (state: Types.RootState, ownProps: { id: string }) => ownProps.id,
  byId,
  (id, byId) => R.pipe(byId, R.prop(id)),
);

// Raw list — insertion order. Use `listSortedAsc` for UI ordering.
export const list = createSelector(allIds, byId, (allIds, byId) =>
  R.pipe(
    allIds,
    R.map((id) => R.pipe(byId, R.prop(id))),
    R.filter(R.isDefined),
  ),
);

// Ascending sortOrder. Drives the filter chip order and the create-time
// preselect (defaultImprovementAreaId picks `[0]`).
export const listSortedAsc = createSelector(list, (areas) =>
  R.pipe(areas, R.sortBy([R.prop('sortOrder'), 'asc'])),
);

// First (lowest sortOrder) area, or null when the tenant has none configured.
// Used by the mock-create sagas to preselect the area for new entities.
export const defaultImprovementAreaId = createSelector(
  listSortedAsc,
  (sorted) => {
    const first = sorted[0];
    if (!R.isDefined(first)) return null;
    return first.id;
  },
);
